module.exports = __webpack_public_path__ + "static/media/400337_01.2c7a5a1f.png";